/* eslint-disable no-unused-vars */

// suggest improvements for this component
// give me the entire code to copy


import React, { lazy, Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Header from '../components/Header';
import Footer from '../components/Footer';
import ShopBanner from '../components/ShopBanner';
import GetSellerConfig from '../components/GetSellerConfig';

const DefaultAboutUs            = lazy(() => import('./clientPages/DefaultAboutUs'));
const KosherCateringMeatAboutUs  = lazy(() => import('./clientPages/KosherCateringMeatAboutUs'));
const KosherCateringDairyAboutUs = lazy(() => import('./clientPages/KosherCateringDairyAboutUs'));

const SELLER_COMPONENT_MAP = {
  'Kosher Catering Meat':  KosherCateringMeatAboutUs,
  'Kosher Catering Dairy': KosherCateringDairyAboutUs,
  Default:                 DefaultAboutUs,
};

const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-20">
    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-600" />
  </div>
);

const AboutUs = () => {
  const { seller } = useSelector((state) => state.seller);
  const sellerCompanyName = seller?.shopName;
  // const sellerCompanyNameSlug = seller?.shopNameSlug;
    const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
    const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
    const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1    
    const sellerSecondaryColor2 = seller?.frontEndSecondaryColor2
    const { sellerComponentBackgroundColor } = GetSellerConfig();

    const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
    const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
  const SellerAboutUs = useMemo(
    () => SELLER_COMPONENT_MAP[sellerCompanyName] ?? SELLER_COMPONENT_MAP.Default,
    [sellerCompanyName]
  );

  return (
    <div>
      <Header />
      <div className="">
          <ShopBanner homePage="Home"
            homeLink="/"
            currentPageTop="About Us"
            currentPageTopLink=""
            currentPageBottom1="About Us"
            currentPageBottomLink1=""
            currentPageBottom2=""
            currentPageBottomLink2=""
          />
      </div>
      <div className="w-full mt-0"
        style={{ backgroundColor: sellerComponentBackgroundColor }}>
        <div className="w-[85%] flex-wrap mx-auto pt-4">
          <div>
            <Suspense fallback={<LoadingSpinner />}>
                <SellerAboutUs />
            </Suspense>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;



// my original code
// import React, { lazy } from 'react';
// import { useSelector } from 'react-redux';

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';

// const DefaultAboutUs = lazy(()=> import('./clientPages/DefaultAboutUs'))
// const KosherCateringMeatAboutUs  = lazy(()=> import('./clientPages/KosherCateringMeatAboutUs')) 
// const KosherCateringDairyAboutUs = lazy(()=> import('./clientPages/KosherCateringDairyAboutUs'))

// const AboutUs = () => {
//     const { seller } = useSelector(state => state.seller)
//     const sellerCompanyName = seller?.shopName
//     const sellerCompanyNameSlug = seller?.shopNameSlug
//     const LoadComponent = () => {
//     //const isLoggedIn = props.isLoggedIn;
//         if (sellerCompanyName === 'Kosher Catering Meat') {
//             return <KosherCateringMeatAboutUs />
//         } else if (sellerCompanyName === 'Kosher Catering Dairy') {
//             return <KosherCateringDairyAboutUs />
//         } else {
//             return <DefaultAboutUs />
//         }
//     }

//     return (
//         <div>
//             <Header/>
//             <div className='w-full mt-2'>
//                 <div className='w-[85%] flex-wrap mx-auto'>
//                     <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={'About Us'} currentPageTopLink={''} 
//                         currentPageBottom1={'About Us'} currentPageBottomLink1={''} currentPageBottom2={''} currentPageBottomLink2={''} />
//                     {
//                         LoadComponent()
//                     }
//                 </div>
//             </div>
//             <Footer/>
//         </div>
//     );
// };

// export default AboutUs;


